// extracted by mini-css-extract-plugin
export default {"inputsDiv":"Inputs_inputsDiv__SKzej","label":"Inputs_label__40Zty","inputs":"Inputs_inputs__63Y6c"};